import React, { useEffect } from 'react';
import { Typography, Grid, InputLabel } from '@mui/material';
import Message from './messages/Message';
import CommandeRecap from './CommandeRecap';
import CommuneAutocomplete from './forms/CommuneAutocomplete';
import GenericText from './forms/GenericText';
import ClientType from './forms/ClientType';
import Civilite from './forms/Civilite';
import NumeroTelephone from './forms/NumeroTelephone';
import { useCommandeContext } from '../contexts/CommandeContext';
import GenericCheckbox from './forms/GenericCheckbox';
import { saveAs } from 'file-saver';
import { Link } from 'react-router-dom';
import CommandeCodePromo from './CommandeCodePromo';
import CommandeTypePaiement from './CommandeTypePaiement';

export default function EtapeDevisPaiement({ props, clientType, displayPaiement }) {

	// Recupération de la commande et du dispatcher à partir du CommandeContext
	const { commande } = useCommandeContext();

	const telechargerCGV = () => {
		saveAs(process.env.REACT_APP_PATH_PDF + '/Conditions_générales_de_vente_ELLIAN.pdf', 'Conditions générale de vente ELLIAN.pdf');
	};
	
	useEffect(() => {
		const element = document.getElementById('titrePaiement');
		if (element) {
			element.scrollIntoView({ behavior: 'smooth' });
		}
	}, []);

	return (
		<>

			<CommandeRecap />

			<CommandeTypePaiement disabled={displayPaiement} />

			<Grid container justifyContent="center">

				<CommandeCodePromo disabled={displayPaiement} />

				<Grid item xs={12}>
					<Typography id="titreFacturation" component="h3" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 26, md: 36, lg: 36 }, fontWeight: 400, textAlign: 'center', my: 2 }}>
						Contacts et facturation
					</Typography>
				</Grid>

				<Grid item xs={12} sm={12} md={11} lg={11} xl={8}>
					<Grid container spacing={2}>

						<Message props={{ type: 'info', message: 'Saisissez vos contacts et détails de facturation avant de pouvoir procéder au paiement en ligne.' }} />

						<Grid item xs={4} sm={4}>
							<InputLabel sx={{ fontSize: 18, paddingTop: '7px' }}>Vous êtes :</InputLabel>
						</Grid>
						<Grid item xs={8} sm={8}>
							<ClientType props={{ id: 'clientType', disabled: displayPaiement }} />
						</Grid>

						{
							clientType === 'entreprise' &&
							<>
								<Grid item xs={12} sm={12} md={6}>
									<GenericText
										required={true}
										disabled={displayPaiement}
										id="clientNomEntreprise"
										name="clientNomEntreprise"
										label="Nom de l'entreprise"
									/>
								</Grid>
								<Grid item xs={12} sm={12} md={6}>
									<GenericText
										disabled={displayPaiement}
										id="clientIdentifiantEntreprise"
										name="clientIdentifiantEntreprise"
										label="SIRET / SIREN"
									/>
								</Grid>
							</>
						}

						<Grid item xs={4} sm={4} md={2}>
							<Civilite props={{ id: 'contactCivilite', label: 'Civilité', disabled: displayPaiement }} />
						</Grid>

						<Grid item xs={8} sm={8} md={4}>
							<GenericText
								required={true}
								disabled={displayPaiement}
								id="contactPrenom"
								name="contactPrenom"
								label="Prénom"
							/>
						</Grid>

						<Grid item xs={12} sm={12} md={6}>
							<GenericText
								required={true}
								disabled={displayPaiement}
								id="contactNom"
								name="contactNom"
								label="Nom"
							/>
						</Grid>

						<Grid item xs={12} sm={6}>
							<NumeroTelephone props={{ id: 'contactTelephoneMobile', label: 'Téléphone Mobile', required: true, disabled: displayPaiement, placeholder: 'ex: 0612345678' }} />
						</Grid>

						<Grid item xs={12} sm={6}>
							<NumeroTelephone props={{ id: 'contactTelephoneFixe', label: 'Téléphone Fixe', disabled: displayPaiement, placeholder: 'ex: 0412345678' }} />
						</Grid>

						<Grid item xs={12} sm={6}>
							<GenericText
								required={true}
								disabled={displayPaiement}
								id="contactEmail"
								name="contactEmail"
								label="Adresse e-mail" />
						</Grid>

						<Grid item xs={12} sm={6}>
							<GenericText
								required={true}
								disabled={displayPaiement}
								id="contactEmailConfirmation"
								name="contactEmailConfirmation"
								label="Confirmation adresse e-mail" />
						</Grid>

						<Grid item xs={12}>
							<CommuneAutocomplete id="commune" required={true} disabled={true} />
						</Grid>

						<Grid item xs={12}>
							<GenericText
								required={true}
								disabled={true}
								id="adresse"
								label="Adresse de l'intervention (Numéro et voie)" />
						</Grid>

						<Grid item xs={12}>
							<GenericText
								disabled={displayPaiement}
								id="adresseComplement"
								label="Complément d'adresse (Résidence, Bâtiment, Etage, ...)" />
						</Grid>

						<Grid item xs={12}>
							<GenericCheckbox
								checked={commande.hasAdresseFacturation}
								disabled={displayPaiement}
								id="hasAdresseFacturation"
								label="Cocher la case si l'adresse de facturation est différente de l'adresse d'intervention."
							/>
						</Grid>

						{
							commande.hasAdresseFacturation &&
							<>
								<Grid item xs={12}>
									<CommuneAutocomplete id="communeFacturation" required={true} disabled={displayPaiement} />
								</Grid>

								<Grid item xs={12}>
									<GenericText
										disabled={displayPaiement}
										id="adresseFacturation"
										label="Adresse (Numéro et voie)"
										required={true} />
								</Grid>

								<Grid item xs={12}>
									<GenericText
										disabled={displayPaiement}
										id="adresseComplementFacturation"
										label="Adresse complément (Résidence, Bâtiment, Etage, ...)" />
								</Grid>
							</>
						}

						{
							<>
								<Grid item xs={12}>
									<GenericCheckbox
										checked={commande.isPlus2ans}
										disabled={displayPaiement}
										id="isPlus2ans"
										label="En cochant cette case, je déclare que mon habitation a plus de 2 ans ou que l'installation concernée par la prestation choisie a plus de 2 ans (Information nécessaire au calcul de la TVA)."
									/>
								</Grid>
								<Grid item xs={12}>
									<GenericCheckbox
										checked={commande.acceptCGV}
										disabled={displayPaiement}
										id="acceptCGV"
										label="J'accepte et je reconnais avoir pris connaissance des "
									/>
									<Link onClick={telechargerCGV}>Conditions générales de vente</Link>.
								</Grid>
							</>
						}

						{!props.validation.isValid &&
							<Message props={{ type: 'error', message: props.validation.messageErreur }} />
						}
						{props.validation.isValid && props.error &&
							<Message props={{
								type: 'error',
								titre: 'Oups ... Nous rencontrons un problème technique !',
								message: '<p>Si le problème persiste vous pouvez contacter notre service client :</p>',
								contact: true
							}} />
						}
					</Grid>

				</Grid>
			</Grid>

		</>
	);
}